import { createNode } from '@glueapp/graph-types';

export const ListContains = createNode({
    id: 'List Contains',
    name: 'List Contains',
    description: 'Finds out if a List returns a given value',
    aiDescription: 'Checks whether a list contains a specific value. Connect "List" and "Search Value". Output: "Found" (boolean).',
    category: 'List',
    color: '#778ed5',
    integration: undefined,
    inPorts: {
        List: {
            kind: 'array',
            subType: {
                kind: 'generic',
                identifier: 'T',
            },
        },
        'Search Value': {
            kind: 'generic',
            identifier: 'T',
        },
    },
    outPorts: {
        Found: {
            kind: 'boolean',
        },
    },
    execute: function (input) {
        return { output: { Found: input.inPorts.List.indexOf(input.inPorts['Search Value']) >= 0 } };
    },
});
